import { connect } from "react-redux";
import { Link } from "react-router-dom";

var AccountPlans = require("lib/account/AccountPlans");
var CurrentUser = require("lib/account/CurrentUser");


var UIActions = require("lib/actions/UIActions");

var PaywallModal = require("components/users/teachers/PaywallModal");

var Glyphicon = require("components/utility/icons/Glyphicon");

require("users/teachers/upgrade/overdrawn_account_notice.scss");

@connect(
	() => ({}),
	(dispatch, props) => ({
		showPaywall: () =>
			dispatch(UIActions.showPaywall({ paywall: PaywallModal.OVERDRAWN_ACCOUNT })),
	})
)
class OverdrawnAccountNotice extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	getPlanName() {
		var planType = CurrentUser.get().account.plan_type || AccountPlans.STARTER_PLAN;
		return AccountPlans.name(planType);
	}

	getUpgradePath() {
		var planType = CurrentUser.get().account.plan_type || AccountPlans.STARTER_PLAN;
		return "/upgrade?plan=" + AccountPlans.increaseType(planType)
	}

	maxClassText() {
		var classCount = CurrentUser.get().account.max_student_list_count;
		return $wr.pluralizeWithNumber("class", classCount, "classes");
	}

	maxStudentText() {
		var studentCount = CurrentUser.get().account.max_students_count;
		return $wr.pluralizeWithNumber("student", studentCount);
	}

	onUpgrade(e) {
		$wr.nope(e)
		var planType = CurrentUser.get().account.plan_type;
		if (planType == AccountPlans.STARTER_PLAN || planType == undefined) {
			this.props.showPaywall();
		} else {
			$wr.redirect(this.getUpgradePath())
		}
	}

	render() {
		if (this.props.source == "roster") {
			// when on the roster, link to the help section
			var classesLink = "https://whooosreading.zendesk.com/hc/en-us/articles/115001333471";
			var reorganizeLink = "https://whooosreading.zendesk.com/hc/en-us/articles/115001704531"
			var fixLink = (
				<span>
					<a href={ classesLink } target="_blank">
						Archive classes
					</a>
					<div className="verticalDivider" />
					<a href={ reorganizeLink } target="_blank">
						Reorganize
					</a>
				</span>
			);
		} else {
			// link to the roster on every other page
			var fixLink = (<Link to={ "/roster" }>Reduce your roster</Link>);
		}


		return (
			<div className="overdrawnAccountNotice hideOnPrint">
				<div className="noticeBox">
					<div className="statusDescription">
						Your student accounts are frozen because you are over your
						{ " " + this.getPlanName() } plan limits of <b>{ this.maxClassText() }</b> with
						{ " " }<b>{ this.maxStudentText() }</b> each.
					</div>
					<div className="actionOptions">
						To unfreeze your accounts:
						<br/>
						{ " " }{ fixLink }
						<div className="verticalDivider" />
						<a href="#" onClick={ this.onUpgrade }>Upgrade</a>
					</div>
				</div>
			</div>
		);
	}
}

OverdrawnAccountNotice.WrappedComponent.propTypes = StrictPropTypes({
	// location of notice, for changing link to roster vs help section
	source: PropTypes.string.isRequired,

	showPaywall: PropTypes.func.isRequired
});

module.exports = OverdrawnAccountNotice;


// WEBPACK FOOTER //
// ./modules/components/users/teachers/upgrade/OverdrawnAccountNotice.js